import {Color} from '@benchling/nucleus-ui';
import {createStyles} from '@mantine/core';
import type {CSSObject, MantineTheme} from '@mantine/core';

export const usePillStyles = createStyles(() => ({
  iconWrapper: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 18,
    height: 18,
    borderRadius: 27,
    backgroundColor: Color.GRAY_100,
    color: Color.GRAY_600,
  },
  // Icon inside a pill trigger and its dropdown chevron.
  pillIcon: {
    fontSize: 12,
  },
  pillChevron: {
    fontSize: 8,
  },
}));

// Shared visual treatment for every omnibox filter pill (type toggles and dropdown triggers).
export function pillSx(isActive: boolean): (theme: MantineTheme) => CSSObject {
  return (theme: MantineTheme) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: 5,
    width: 'fit-content',
    height: 22,
    whiteSpace: 'nowrap' as const,
    borderRadius: 10,
    border: `1px solid ${Color.GRAY_300}`,
    padding: '2px 9px 2px 2px',
    // Pills keep one font size so selecting one doesn't resize the row; active pills switch to
    // 600 weight in blue[7] (BLUE_450), inactive pills stay 400 in GRAY_900.
    fontSize: theme.fontSizes.xxs,
    fontWeight: isActive ? 600 : 400,
    lineHeight: '16px',
    letterSpacing: 0,
    color: isActive ? theme.colors.blue[7] : Color.GRAY_900,
    backgroundColor: isActive ? theme.colors.blue[0] : 'transparent',
    transition: 'all 100ms ease',
    '&:hover': {
      backgroundColor: isActive ? theme.colors.blue[0] : theme.colors.gray[0],
    },
  });
}
